import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { ClockIcon } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-12 px-4 bg-red-50 border-y border-red-100" data-id="element-304">
      <div className="max-w-3xl mx-auto text-center" data-id="element-305">
        <div className="flex justify-center mb-4" data-id="element-306">
          <ClockIcon className="w-12 h-12 text-red-500 animate-pulse" data-id="element-307" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-red-600 mb-6" data-id="element-308">
          OFFERTA SPECIALE A TEMPO LIMITATO
        </h2>
        <p className="text-lg text-gray-700 mb-6" data-id="element-309">
          Questa offerta con tutti i bonus inclusi scade tra:
        </p>
        <div className="flex justify-center" data-id="element-310">
          <CountdownTimer className="text-2xl md:text-4xl" data-id="element-311" />
        </div>
      </div>
    </section>;
}